import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { eur, monthLabel } from "./format";

const SERIES = [
  { key: "orders_value", name: "Orders written", color: "#22d3ee" },
  { key: "cost_value", name: "Supplier costs", color: "#fb7185" },
  { key: "po_value", name: "Customer POs", color: "#f59e0b" },
  { key: "invoiced_value", name: "Invoiced", color: "#34d399" },
];

const TrendTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg bg-slate-900 p-3 text-xs ring-1 ring-white/10 shadow-xl">
      <p className="mb-2 font-bold text-slate-200">{monthLabel(label)}</p>
      {payload.map((p) => (
        <p key={p.dataKey} className="flex items-center justify-between gap-6 text-slate-300">
          <span className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-sm" style={{ backgroundColor: p.color }} />{p.name}{p.dataKey === "invoiced_value" && <span className="text-[10px] text-slate-500">{p.payload?.invoiced_basis === "manual" ? "(manual)" : p.payload?.invoiced_basis === "report" ? "(report)" : "(status)"}</span>}</span>
          <span className="font-mono font-semibold text-slate-100">{eur(p.value)}</span>
        </p>
      ))}
      {payload[0]?.payload?.margin_pct !== null && payload[0]?.payload?.margin_pct !== undefined && (
        <p className="mt-2 border-t border-white/10 pt-2 text-right text-slate-300">
          Margin <span className="font-mono font-semibold text-amber-200">{eur(payload[0].payload.margin_value)}</span> · {payload[0].payload.margin_pct}%
        </p>
      )}
    </div>
  );
};

export const TrendChart = ({ trend, selectedMonth }) => (
  <div className="rounded-2xl bg-slate-900/70 p-6 ring-1 ring-white/5" data-testid="sales-trend-chart">
    <div className="mb-4 flex items-center justify-between">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">Last 6 months</p>
        <p className="mt-0.5 text-sm text-slate-500">Value per month · highlighted bar set is the selected month</p>
      </div>
    </div>
    <div className="h-72">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={trend} barGap={3} barCategoryGap="28%">
          <CartesianGrid vertical={false} stroke="#1e293b" />
          <XAxis dataKey="month" tickFormatter={(m) => monthLabel(m, "short")} stroke="#475569" tick={{ fill: "#94a3b8", fontSize: 12 }} axisLine={false} tickLine={false} />
          <YAxis tickFormatter={(v) => (v >= 1000 ? `€${Math.round(v / 1000)}k` : `€${v}`)} stroke="#475569" tick={{ fill: "#94a3b8", fontSize: 12 }} axisLine={false} tickLine={false} width={56} />
          <Tooltip content={<TrendTooltip />} cursor={{ fill: "rgba(148,163,184,0.08)" }} />
          <Legend itemSorter={null} wrapperStyle={{ fontSize: 12, color: "#cbd5e1", paddingTop: 12 }} iconType="square" iconSize={10} />
          {SERIES.map((s) => (
            <Bar key={s.key} dataKey={s.key} name={s.name} fill={s.color} radius={[4, 4, 0, 0]} fillOpacity={0.9}
              shape={(props) => {
                const dim = props.payload?.month !== selectedMonth;
                const { x, y, width, height } = props;
                return <rect x={x} y={y} width={width} height={Math.max(0, height)} rx={3} fill={s.color} fillOpacity={dim ? 0.35 : 1} />;
              }}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
);
